/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.cms
 */
function cmsContentDirective() {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            sectionKey: '@',
            cmsContext: '=',
            categoryId: '='
        },
        controller: cmsContentDirectiveCtrl,
        template: '<ng-transclude ng-bind-html="content | trust"></ng-transclude>'
    };
}

cmsContentDirectiveCtrl.$inject = [
    '$scope',
    '$timeout',
    'CmsContentService',
];
function cmsContentDirectiveCtrl(
    $scope,
    $timeout,
    CmsContentService
) {
    // Retrieve the content for the given information in the next digest cycle
    $timeout(
        getText
    );

    $scope.$watch('sectionKey', function(newVal, oldVal) {
        if (newVal !== oldVal) {
            getText();
        }
    });

    // We're using inequality checks to prevent the initial calls
    $scope.$watch('cmsContext', function (newVal, oldVal) {
        if (newVal !== oldVal) {
            getText();
        }
    }, true);
    $scope.$watch('categoryId', function(newVal, oldVal) {
        if (newVal !== oldVal) {
            getText();
        }
    });

    function getText() {
        CmsContentService.getMarketPlaceText($scope.sectionKey, $scope.cmsContext, $scope.categoryId).then(function(text) {
            if (text) {
                $scope.content = text;
            }
        });
    }
}

module.exports = cmsContentDirective;